import { Component, Input } from '@angular/core';

import { StudentAiTimelineComponent } from './student-ai-timeline';

@Component({
  selector: 'app-student-time-line',
  templateUrl: './student-time-line.component.html',
  styleUrl: './student-time-line.component.scss'
})
export class StudentTimeLineComponent {

  @Input({ required: true })
 studentId!: string;
}
